import AccordionCustomComponent from "components/common/layouts/Accordion";
import { CopyButton } from "components/common/ui/Buttons/Copy-Button";
import { useSelector } from "react-redux";
export function ParkPage() {
  const uid = useSelector((state: any) => state.firebase.auth.uid);
  const link = `https://tickets.touritickets.de/park/${uid}/`;
  return <AccordionCustomComponent title={"TouriTickets - Park Page"}>
			<CopyButton value={link} />
		</AccordionCustomComponent>;
}